
export const parseDateString = (dateString) => {
    if (!dateString) return null;
    const [datePart, timePart] = dateString.split(' ');
    const [day, month, year] = datePart.split('-');

    const formattedDate = `${month}/${day}/${year} ${timePart}`;
    const date = new Date(formattedDate);

    return isNaN(date.getTime()) ? null : date;
};